import { ChangeEventHandler, FC } from 'react';
import BasicModal from '../common/BasicModal';
import { useTranslation } from 'react-i18next';
import { Box, Button, TextField, Typography } from '@mui/material';
import Upload from '../common/Upload';

type IAddScreenShotModal = {
	open: boolean;
	screenShotTitle: string;
	screenShotPageId: string;
	screenShotDescription: string;
	files: (File | string)[];
	loading: boolean;
	setFiles: React.Dispatch<React.SetStateAction<(File | string)[]>>;
	onClose: () => void;
	onCancel: () => void;
	onSave: () => void;
	onScreenShotTitleChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
	onScreenShotPageIdChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
	onScreenShotDescriptionChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
};

const AddScreenShotModal: FC<IAddScreenShotModal> = ({ open, loading, files, screenShotTitle, screenShotPageId, screenShotDescription, setFiles, onClose, onCancel, onSave, onScreenShotTitleChange, onScreenShotDescriptionChange, onScreenShotPageIdChange }) => {
	const { t } = useTranslation();

	const isEnabled = files.length > 0 && screenShotPageId && screenShotTitle && screenShotDescription;

	return (
		<BasicModal className="relative min-h-[660px] max-w-[630px]" open={open} onClose={onClose} title={t('add_screenshot')} showBackIcon={false}>
			<Box className="mt-8 flex flex-col gap-6">
				{loading ? (
					<Typography className="flex self-center">{t('uploading')}</Typography>
				) : (
					<>
						<TextField fullWidth onChange={onScreenShotTitleChange} label={t('title')} value={screenShotTitle} />
						<TextField fullWidth onChange={onScreenShotPageIdChange} label={t('advertised_page_id')} value={screenShotPageId} />
						<TextField fullWidth onChange={onScreenShotDescriptionChange} label={t('description')} multiline rows={5} value={screenShotDescription} />

						<Upload className="" files={files} setFiles={setFiles} text={t('image_uploader_label')} />

						<Box className="flex items-center justify-end gap-4">
							<Button variant="outlined" className="border-action-disabledBackground text-action-disabled" size="large" onClick={onCancel}>
								{t('cancel')}
							</Button>
							<Button className="min-w-32" size="large" onClick={onSave} disabled={!isEnabled}>
								{t('register')}
							</Button>
						</Box>
					</>
				)}
			</Box>
		</BasicModal>
	);
};

export default AddScreenShotModal;
